var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ArchivePublication extends Component {
    constructor() {
        super('ArchivePublication', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($(window).width() >= 992) {
                $('.publication').on('click', (event, publication) => {
                    $('.publication-details').addClass('d-none');
                    $(publication.attr('href')).removeClass('d-none');
                }); /*.on('mouseleave', () => {
                  $('.publication-details').addClass('d-none');
                });*/
            }
            else {
                $('.publication').on('click', (event, publication) => {
                    event.preventDefault();
                    $('.scrollable-column-lg .btn-toggle-content').removeClass('is-active');
                    $('.scrollable-column-lg').addClass('is-opened');
                    $('.publication-details').addClass('d-none');
                    $(publication.attr('href')).removeClass('d-none');
                });
            }
            this.computeHeight();
            this.success();
        });
    }
    computeHeight() {
        const lastImage = $('#grid-layout-image-9');
        const gridLayout = $('.grid-layout');
        const bottom = $('#grid-layout-image-9').position(gridLayout).y + lastImage.height();
        gridLayout.css('min-height', bottom + 50);
    }
}
